import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-css-day3',
  templateUrl: './css-day3.component.html',
  styleUrls: ['./css-day3.component.css']
})
export class CssDay3Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
